<template>
    <div>
        <div class="padding pt-3">
            <div class="row">
                <div class="col-12">
                    <!--<strong>5,981 Companies</strong>, 199 companies have surging topics --><button v-if="routedFrom=='search'" class="btn ml-2 btn-white" @click="savePersona">Save</button>
                    <div v-if="personaSaved">
                      <br>
                      <div class="alert alert-success alert-dismissible fade show" key="success-alert" role="alert">
                        You saved the persona successfully.
                      </div>
                    </div>
                </div>
                

            </div>
        </div>
        <div v-if="routedFrom=='search'" class="padding company-filters pb-1 pt-1">
            <div class="row">
                <div class="col-12">
                    <a href="#" @click="openModal()" data-toggle="modal" data-target="#modal-right" data-toggle-class="modal-open-aside">
                        <filter-icon width="16" height="16"></filter-icon>
                        Filter Company
                    </a>
                    <!--<a href="#" class="ml-5"><file-text-icon width="16" height="16"></file-text-icon>Export to CSV</a>-->
                </div>
            </div>
        </div>
        <div class="padding">
          <div class="table-responsive">
            <table id="table" class="table table-theme v-middle">
                <thead>
                    <tr>
                        <th v-if="routedFrom=='search'" style="width:20px;"></th>
                        <th class="text-muted" style="width:40px;text-align:center">Rank</th>
                        <th class="text-muted">Company Name</th>
                        <th class="text-muted">Linkedin</th>
                        <th v-if="routedFrom=='search'" class="text-muted">Relevance</th>
                        <th class="text-muted">Employees</th>
                        <th class="text-muted">Country</th>
                        <th v-if="routedFrom=='search'" class="text-muted" style="width:120px;">Score</th>
                        <th style="width:50px;"></th>
                        <th v-if="routedFrom=='personas'" style="width:50px;"></th>
                    </tr>
                </thead>
                <tbody class="list">
                    <tr class="v-middle" :key="company.id" v-for="(company, index) in paginatedItems">
                        <td v-if="routedFrom=='search'">
                            <label class="ui-check m-0 ">
                                <input type="checkbox" name="id" :value="company.id">
                                <i></i>
                            </label>
                        </td>
                        <td style="min-width:30px;text-align:center">
                            <small class="text-muted">{{company.rank}}</small>
                        </td>
                        <td class="flex">
                            <a :href="'http://' + company.domain" class="item-company ajax h-1x" target="_blank">
                                {{company.name || company.domain}}
                            </a>
                            <div class="item-mail text-muted h-1x d-none d-sm-block">
                                {{company.industry}}
                            </div>
                        </td>
                        <td>
                          <div v-if="company.linkedin_name">
                            <a :href="'https://linkedin.com/' + company.linkedin_name" target="_blank">
                                <linkedin-icon class="custom-class" width="16" height="16"></linkedin-icon>
                            </a>
                          </div>
                        </td>
                        <td v-if="routedFrom=='search'">
                          <button @click="submitVote(company, 1)"  
                                  :class="{clicked: company.feedback==1}" 
                                  class="btn bg-success-lt related-button bg-success-lt mb-1">
                                  Related
                          </button>
                          <button @click="submitVote(company, -1)" 
                                  :class="{clicked: company.feedback==-1}" 
                                  class="btn bg-danger-lt not-related-button">
                                  Not related
                          </button>
                        </td>
                        <td>
                            <span class="item-amount d-none d-sm-block text-sm ">{{company.numberofemployees}}</span>
                        </td>
                        <td>
                            {{company.country}}
                        </td>
                        <td v-if="routedFrom=='search'" class="no-wrap">
                            <div class="item-date text-muted text-sm d-none d-md-block">
                              <star-rating :rating="computeRating(company.distance)" :read-only="true" :show-rating="false" :star-size="20"></star-rating>
                            </div>
                        </td>
                        <td>
                          	<router-link class="btn w-sm mb-1 btn-light" :to="/companyProfile/+company.id+'/'+company.name" tag="a" role="button">View Profile</router-link>
                        </td>
                        <td v-if="routedFrom=='personas'" class="no-wrap">
                          <button @click="removeFromPersona(index)" class="btn w-sm mb-1 bg-danger-lt">
                              Delete
                          </button>
                        </td>
                    </tr>
                </tbody>
            </table>
          </div>
          <!-- v-model="currentPage" -->
          <Paginate :pageCount="pageCount"
                    v-model="selectedPage"
                    :click-handler="onPageChange"
                    :containerClass="'pagination'">
          </Paginate>
        </div>
        <div>
          <FilterModal :filterData="generateFilterModalData()" @filter="applyFilters" @clear="clearFilters" v-show="modalVisible" @close="closeModal"/>
        </div>
    </div>
</template>

<script type="text/javascript">
  import Vue from 'vue';
  import { LinkedinIcon, FilterIcon, FileTextIcon} from 'vue-feather-icons';
  import Paginate from 'vuejs-paginate'
  import FilterModal from '@/components/FilterModal.vue';
  import StarRating from 'vue-star-rating';

  export default {
    name: 'RecommendationList',
    props: {
      'source': {
        type: Object,
        default: {}
      },
      'recommendations': {
        type: Array,
        default: []
      },
      'currentPage': {
        type: Number,
        default: 1
      },
      'persona_id':{
        type: Number,
        default: -1
      },
      'routedFrom':{
        type: String,
        default: ''
      },
    },
    components: {
        FilterModal,
        LinkedinIcon,
        FilterIcon,
        FileTextIcon,
        StarRating,
        Paginate
    },
    data() {
      return {
            filterModalData: {},
            selectedFilters: {},
            modalVisible: false,
            selectedPage: this.currentPage,
            pageSize: 10,
            personaSaved: false,
          };
    },
    computed: {
      filteredItems() {
        return this.filterItems(this.recommendations, this.selectedFilters);
      },
      totalRows() {
        return this.filteredItems.length;
      },
      pageCount() {
        return Math.ceil(this.totalRows/this.pageSize);
      },
      paginatedItems() {
        return this.paginate(this.filteredItems, this.selectedPage, this.pageSize);
      },
    },
    watch: {
      currentPage(newPage, oldPage) {
        this.selectedPage = newPage;
      },
    },
    methods:{
      get_ids_of_recommendations(){
        var rec_ids = [];
        for (var i = 0; i < this.recommendations.length; i++) {
          if(this.recommendations[i].feedback!= -1){
            rec_ids.push(this.recommendations[i].id);
          }
        }
        return rec_ids;
      },
      removeFromPersona(index){
        console.log("Removed");
        this.recommendations.splice(index, 1)
        for (var i = index; i < this.recommendations.length; i++) {
          this.recommendations[i]['rank'] -= 1
        }
        const path = process.env.API_LOCATION + `/update_persona`;
        var that=this;
        var rec_ids = this.get_ids_of_recommendations();

        this.$http.get(path, {params: {persona_id: that.persona_id, rec_ids: rec_ids}})
            .then((res) => {
              console.log("Persona updated successfully.");
            })
            .catch((error) => {
              console.log("Error while updating persona.");
              console.error(error);
            });
      },
      savePersona(){
        const path = process.env.API_LOCATION + `/save_persona`;
        var that=this;
        var rec_ids = this.get_ids_of_recommendations();

        this.$http.get(path, {params: {source_id: that.source.id, source_domain: that.source.domain, rec_ids: rec_ids}})
            .then((res) => {
              console.log("Persona saved successfully.");
              console.log(res);
              this.personaSaved = true;
              setTimeout(function(){
                  this.personaSaved = false;
              }.bind(this), 5000);
            })
            .catch((error) => {
              console.log("Error while saving persona.");
              console.error(error);
            });
      },
      computeRating(distance){
        if(distance<=0.8) return 5;
        else if(distance<=1.3) return 4;
        else if(distance<=1.8) return 3;
        else if(distance<=2.3) return 2;

        return 1;
      },
      generateFilterModalData(){
        const fieldsToFilter = ['name', 'industry', 'country', 'numberofemployees']
        var filterModalData = {};

        // Initialize filter fields
        for (let i = 0; i < fieldsToFilter.length; i++) {
          filterModalData[fieldsToFilter[i]] = new Set([]);
        }

        // Fill the filter options from values of recommended companies
        for(let i=0; i<this.recommendations.length; ++i){
          for (let j = 0; j < fieldsToFilter.length; ++j){
            var field = fieldsToFilter[j];
            if(this.recommendations[i][field]!=='' && this.recommendations[i][field]!==null)
              filterModalData[field].add(this.recommendations[i][field]);
          }
        }

        // Sort the options
        for (let i = 0; i < fieldsToFilter.length; i++){
          var field = fieldsToFilter[i];
          filterModalData[field] = Array.from(filterModalData[field]);
          if(filterModalData[field].every(x => typeof x === 'number')){
            filterModalData[field] = filterModalData[field].sort((a, b) => (a - b))
          }
          else{
            filterModalData[field] = filterModalData[field].sort()
          }
        }
        this.filterModalData = [...filterModalData]

        return filterModalData;
      },

      applyFilters(selected){
        this.selectedFilters = selected;
        this.selectedPage = 1;
      },

      clearFilters(){
        this.selectedFilters = {};
      },

      filterItems(items, selected) {
        return items.filter(function(rec) {
          for (var key in selected) {
            if(!selected[key].includes(rec[key]))
              return false;
        }
          return true;
        });
      },

      paginate(items, currentPage, pageSize) {       
        var begin = (currentPage-1)*pageSize;
        var end = Math.min(begin + pageSize, items.length);

        return items.slice(begin, end);
      },

      onPageChange(page) {
        this.$emit('pagechange', page);
      },

      submitVote(company, vote) {
        this.$set(company, 'feedback', vote);
        this.$emit('feedback', company.id, vote);
      },

      openModal(){
        this.modalVisible = true;
      },

      closeModal(){
        this.modalVisible = false;
      },
    },
  };

</script>



// WEBPACK FOOTER //
// src/components/RecommendationList.vue